/**
 * V2QsMultiText 컴포넌트 Props 인터페이스
 * V1 QsInputMultiText의 V2 버전 (순수 UI만)
 *
 * 다중 텍스트 태그 입력 컴포넌트
 */

export interface V2QsMultiTextProps {
  /**
   * 태그 배열
   */
  value?: string[];

  /**
   * 값 변경 시 콜백
   */
  onChange?: (value: string[]) => void;

  /**
   * 최소 태그 개수
   */
  min?: number;

  /**
   * 최대 태그 개수
   */
  max?: number;

  /**
   * 비활성화 여부
   */
  disabled?: boolean;

  /**
   * 읽기 전용 여부 (표시 모드)
   */
  readOnly?: boolean;

  /**
   * 에러 상태
   */
  hasError?: boolean;

  /**
   * 에러 메시지
   */
  errorMessage?: string;

  /**
   * 자동 포커스
   */
  autoFocus?: boolean;

  // i18n 텍스트 Props
  /**
   * 플레이스홀더 텍스트
   */
  placeholder?: string;

  /**
   * 추가 버튼 텍스트
   */
  addButtonText?: string;

  /**
   * 최소 개수 미달 에러 메시지 ({{min}} 플레이스홀더 사용)
   */
  minErrorMessage?: string;

  /**
   * 최대 개수 초과 에러 메시지 ({{max}} 플레이스홀더 사용)
   */
  maxErrorMessage?: string;

  /**
   * 추가 CSS 클래스
   */
  className?: string;

  /**
   * 입력 필드 추가 CSS 클래스
   */
  inputClassName?: string;

  /**
   * 태그 추가 CSS 클래스
   */
  tagClassName?: string;
}

export const defaultV2QsMultiTextProps: Partial<V2QsMultiTextProps> = {
  disabled: false,
  readOnly: false,
  hasError: false,
  placeholder: 'Type and add',
  addButtonText: 'ADD',
  minErrorMessage: 'Minimum {{min}} items required',
  maxErrorMessage: 'Maximum {{max}} items allowed',
};
